import translate from '../tools/translate';

const TEMPLATES = {
  PICKUP: () => `${translate('Store')} Collection`,
  COLLECT: ({ title }) => title || 'Collection',
  POST: ({ title }) => title,
  COURIER: ({ address }) => `${translate('Ship')} to ${address} via Courier`,
  POST_EXPRESS: ({ address }) => `Express ${translate('Shipping')} to ${address}`,
  COURIER_EXPRESS: ({ address }) =>
    `Express ${translate('Shipping')} to ${address} via Courier`,
};

const getDeliveryOptionHeadingText = ({ deliveryOption, zipCode }) => {
  const { type, title } = deliveryOption;
  const address = zipCode || 'your address';

  const templateFn = TEMPLATES[type];
  if (templateFn) {
    return templateFn({ title, address });
  }

  return 'No delivery option set';
};

export { getDeliveryOptionHeadingText };
